import Divider from '@mui/material/Divider';
import QButton from 'components/QButton';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  lastDivider: {
    width: '100%',
  },
  stickyButtonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    height: '60px',
    minWidth: '331px',
    width: '100%',
    position: 'sticky',
    bottom: 0,
  },
  flexRow: {
    paddingRight: '8px',
    paddingBottom: '5px',
    paddingTop: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
  },
  cancelButton: {
    width: '95px',
  },
  applyButton: {
    marginLeft: '10px',
    width: '109px',
  },
  innerButtonDiv: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

const InvestmentBottomButtons = React.forwardRef((props, ref) => {
  const { children, cancelFocus, cancelFilter, mySelectedItems, applyFilter, ...otherProps } = props;
  const { classes } = useStyles();

  return (
    <div {...otherProps} ref={ref} className={classes.stickyButtonWrapper}>
      {children}
      <div className={classes.innerButtonDiv}>
        <Divider className={classes.lastDivider} />
        <div className={classes.flexRow}>
          <QButton
            ref={cancelFocus}
            tabIndex={0}
            variant='outlined'
            className={classes.cancelButton}
            onClick={cancelFilter}
            id='cancel_filter_button'
          >
            Cancel
          </QButton>
          <QButton
            tabIndex={0}
            variant='contained'
            disabled={Boolean(!mySelectedItems?.length)}
            className={classes.applyButton}
            onClick={applyFilter}
            id='apply_filter_button'
          >
            Apply
          </QButton>
        </div>
      </div>
    </div>
  );
});

InvestmentBottomButtons.propTypes = {
  children: PropTypes.any,
  mySelectedItems: PropTypes.array,
  applyFilter: PropTypes.func,
  cancelFocus: PropTypes.oneOfType([
    // this is a ref
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  cancelFilter: PropTypes.func,
};

InvestmentBottomButtons.displayName = 'InvestmentBottomButtons';
export default InvestmentBottomButtons;
